import { render, staticRenderFns } from "./inspectscanmap.vue?vue&type=template&id=2c61604e"
import script from "./inspectscanmap.vue?vue&type=script&lang=js"
export * from "./inspectscanmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports